import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import FEDetailsAccordion from '../../../components/DetailsAccordion/FEDetailsAccordion';
import { getDetailsData } from '../FlowEfficiencyActions';

import FlowEfficiencyChart from './FlowEfficiencyChart';
import AvgFE from './AvgFE';

import '../FlowEfficiency.scss';

class WallboardFlowEfficiencyChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chartType !== this.props.chartType) {
      this.props.getDetailsData(this.props.dates);
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Flow Efficiency Chart</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="fe" switchChartType showNavigator showAvgChart options={{ avgChartTooltip: 'Average Flow Efficiency' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.props.data.series && !!this.props.data.series.length && this.props.avgChart && (
            <AvgFE data={this.props.data.series} dateFormat={this.props.dateFormat} />
          )}

          <FEDetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
        </div>
        <div className="diagram_details">
          <FlowEfficiencyChart id="FlowEfficiency" data={this.props.data} onPointClick={this.handlePointClick} />
          <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getDetailsData: dates => dispatch(getDetailsData(dates))
  };
};

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    avgChart: state.filters.fe.avgChart,
    data: state.fe.data,
    dates: state.filters.dates,
    chartType: state.filters.fe.chartType,
    isLoading: state.fe.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WallboardFlowEfficiencyChart);
